/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetCurrentEncounterStatusErrorResponse,
  GetCurrentEncounterStatusResponse,
  GetEncountersCurrentStatusParams,
} from './api.schemas';

import { api } from '../util/http';

export const getEncountersCurrentStatus = (
  params?: GetEncountersCurrentStatusParams,
  signal?: AbortSignal,
) => {
  return api<GetCurrentEncounterStatusResponse>({
    url: `/api/encounters/current-status`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEncountersCurrentStatusQueryKey = (
  params?: GetEncountersCurrentStatusParams,
) => {
  return [`/api/encounters/current-status`, ...(params ? [params] : [])] as const;
};

export const getGetEncountersCurrentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
  TError = GetCurrentEncounterStatusErrorResponse,
>(
  params?: GetEncountersCurrentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersCurrentStatus>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersCurrentStatusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersCurrentStatus>>> = ({
    signal,
  }) => getEncountersCurrentStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersCurrentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersCurrentStatus>>
>;
export type GetEncountersCurrentStatusQueryError = GetCurrentEncounterStatusErrorResponse;

export function useGetEncountersCurrentStatus<
  TData = Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
  TError = GetCurrentEncounterStatusErrorResponse,
>(
  params: undefined | GetEncountersCurrentStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersCurrentStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
          TError,
          Awaited<ReturnType<typeof getEncountersCurrentStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersCurrentStatus<
  TData = Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
  TError = GetCurrentEncounterStatusErrorResponse,
>(
  params?: GetEncountersCurrentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersCurrentStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
          TError,
          Awaited<ReturnType<typeof getEncountersCurrentStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersCurrentStatus<
  TData = Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
  TError = GetCurrentEncounterStatusErrorResponse,
>(
  params?: GetEncountersCurrentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersCurrentStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersCurrentStatus<
  TData = Awaited<ReturnType<typeof getEncountersCurrentStatus>>,
  TError = GetCurrentEncounterStatusErrorResponse,
>(
  params?: GetEncountersCurrentStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersCurrentStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersCurrentStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
